import { render, staticRenderFns } from "./ModeratorProcess.vue?vue&type=template&id=bc3b27bc&"
import script from "./ModeratorProcess.vue?vue&type=script&lang=js&"
export * from "./ModeratorProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports